import { Component, Injector, OnInit } from '@angular/core';
import { ApAlertService, ApComplexModal } from 'webcommon/core-ui';
import { FcSaveAsModalResult } from '../../models/FcSaveAsModalResult';
import { FormBuilder, FormControl, FormGroup, Validators, } from '@angular/forms';

type SaveAsForm = FormGroup<{
  id: FormControl<string | null>;
  name: FormControl<string>;
}>;

@Component({
  providers: [ApAlertService],
  selector: 'fc-filter-save-as-modal',
  templateUrl: './fc-filter-save-as-modal.component.html',
})
export class FcFilterSaveAsModalComponent extends ApComplexModal<FcSaveAsModalResult> implements OnInit {

  isFormValid = false;
  form!: SaveAsForm;
  isSubmitted = false;
  nameControl: FormControl<string>;

  constructor(
    public injector: Injector,
    private readonly fb: FormBuilder,
  ) {
    super(injector);
  }

  override ngOnInit(): void {
    super.ngOnInit();

    this.nameControl = this.fb.nonNullable.control('', { validators: [Validators.required] });
    this.form = this.fb.group({
      id: this.fb.control<string | null>(''),
      name: this.nameControl,
    });
  }

  onSaved() {
    this.isSubmitted = true;
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const { id, name } = this.form.getRawValue();

    super.apClose({
      ID: id ?? null,
      Name: name,
    });
  }

  onCancel(){
    this.apUserCancel();
  }
}
